import Think from './container';

export default Think;



// WEBPACK FOOTER //
// ./src/routes/Think/index.js